import React from 'react';
import { Award, LucideIcon } from 'lucide-react';

interface Criterion {
  title: string;
  icon: LucideIcon;
  description: string;
  details: string;
}

interface EvaluationCriteriaProps {
  criteria: Criterion[];
  openCriteria: string | null;
  onCriteriaToggle: (title: string | null) => void;
}

export default function EvaluationCriteria({ criteria, openCriteria, onCriteriaToggle }: EvaluationCriteriaProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mt-12">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
        <Award className="h-6 w-6 text-primary mr-3" />
        Criterios de Evaluación
      </h2>
      <div className="grid md:grid-cols-2 gap-6">
        {criteria.map((criterion) => {
          const Icon = criterion.icon;
          return (
            <div
              key={criterion.title}
              className="bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => onCriteriaToggle(openCriteria === criterion.title ? null : criterion.title)}
            >
              <div className="flex items-start">
                <div className="p-3 rounded-lg bg-primary/10 mr-4">
                  <Icon className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-2">{criterion.title}</h3>
                  <p className="text-gray-600 text-sm">{criterion.description}</p>
                  {openCriteria === criterion.title && (
                    <p className="mt-4 text-gray-700 text-sm">{criterion.details}</p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}